import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SelectIcon from "../../../assets/img/select-logo-icon.webp";
import JikeiGakuenLogo from "../../../assets/img/JIKEITeamLogo.webp";
import JikeiComLogo from "../../../assets/img/JIKEICOMLogo.webp";

import AdminMenu from "./AdminMenu";
import JikeiMenu from "./JikeiMenu";

import styles from "./sideBar.module.scss";

const SideBar: React.FC = () => {
  const [isSideBarOpen, setIsSideBarOpen] = useState<boolean>(true);

  const { pathname } = useLocation();

  const toggleSideBar = () => {
    setIsSideBarOpen(!isSideBarOpen);
  };

  const sideBarListClass = isSideBarOpen
    ? styles["f-sideBar"]
    : `${styles["f-sideBar"]} ${styles["hide"]}`;

  return (
    <nav className={sideBarListClass}>
      <div
        className={styles["f-sideBar__humbergur-menu"]}
        onClick={() => toggleSideBar()}
      >
        <span></span>
      </div>

      <div className={styles["f-sideBar__SPTop"]}>
        <img src={SelectIcon} />
        <img src={JikeiComLogo} />
        <img src={JikeiGakuenLogo} />
      </div>
      <ul className={styles["f-sideBar__list"]}>
        {pathname.includes("admin") ? (
          <AdminMenu isSideBarOpen={isSideBarOpen} />
        ) : (
          <JikeiMenu isSideBarOpen={isSideBarOpen} />
        )}
      </ul>
      <div
        className={styles["f-sideBar__toggle"]}
        onClick={() => toggleSideBar()}
      >
        <FontAwesomeIcon icon={["fal", "arrow-to-left"]} />
        <span>メニューを折りたたむ</span>
      </div>
    </nav>
  );
};

export default SideBar;
